<div class="sphere-app-container" #appContainer>
  @if (helperService.token && user && !userService.isInWelcomeFlow) {
    <myp-admin-nav></myp-admin-nav>
  }
  <div class="sphere-app-content">
    <router-outlet></router-outlet>
  </div>
  @if (appService.showNavOverlay && user) {
    <myp-cloud-nav-overlay [admin]="true"></myp-cloud-nav-overlay>
  }
  <myp-image-viewer></myp-image-viewer>
  <myp-video-player></myp-video-player>
  <div class="audio-player-container">
    <myp-audio-player [shown]="true"></myp-audio-player>
  </div>
  <myp-action></myp-action>
  <myp-notification></myp-notification>
  <ngx-spinner type="line-scale-pulse-out"></ngx-spinner>
</div>
